import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Core } from '@everfi/reactifi';
import moduleMockData from './mock_contentList.json';

const LessonsContentList = () => {
  // mock data
  const contentList = moduleMockData.data;
  const currentContentList = moduleMockData.application.contentListId;
  const contentListitems = contentList.filter(item => item.id !== currentContentList);

  // pagination state
  const [activePage, setActivePage] = useState(1); // track active page
  const pageSize = 6; // items pre page
  const totalCount = contentListitems.length;
  // calculate items
  const startIndex = (activePage - 1) * pageSize;
  const currentItems = contentListitems.slice(startIndex, startIndex + pageSize);

  // Page change
  const handlePageChange = newPage => {
    setActivePage(newPage);
  };

  const { t } = useTranslation();

  return (
    <Core.Card size="lg">
      <Core.CardHeader stackDirection="row">
        <Core.Typography variant="h1" style={{ margin: 0 }}>
          {t('Lessons')}
        </Core.Typography>
      </Core.CardHeader>
      <Core.CardBody>
        <Core.Layout variant="box" width="100%">
          <Core.ContentList items={currentItems} variant="withCircularProgress" textStyle="h4" />
        </Core.Layout>
      </Core.CardBody>
      <Core.Layout mb="8px" variant="flex" justifyContent="center" width="100%">
        <Core.Pagination
          activePage={activePage}
          data={contentListitems}
          pageSize={pageSize}
          totalCount={totalCount}
          isLoadingData={false}
          maxButtons={5}
          onPageChange={handlePageChange}
        />
      </Core.Layout>
    </Core.Card>
  );
};
export default LessonsContentList;
